function lazyloadInit() {
	window.lazyLoadOptions = {
		elements_selector: "[loading=lazy]",
		use_native: true
	};

	var lazyLoadInstance = new LazyLoad();
}